// Simple Index - Clean React app entry point
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

console.log('🚀 Starting Simple React app...');

// CRITICAL: Extract authorization code from URL BEFORE React renders
// This prevents React Strict Mode from losing the code during double renders
if (window.location.pathname === '/auth/callback') {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const error = urlParams.get('error');
  // Prefer error over code when both exist (OAuth error takes precedence)
  if (error) {
    try {
      sessionStorage.setItem('auth_callback_error', error);
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (e) {
      console.error('❌ Failed to store auth error:', e);
    }
  } else if (code) {
    // Store code in sessionStorage immediately (before React renders)
    // Use a timestamp to track when we captured it
    const callbackData = {
      code,
      state: state || null,
      error: error || null,
      timestamp: Date.now()
    };
    
    try {
      sessionStorage.setItem('auth_callback_code', JSON.stringify(callbackData));
      console.log('💾 Captured auth code from URL (before React render):', code.substring(0, 20) + '...');
      
      // Clear URL immediately to prevent it from being read again
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (e) {
      console.error('❌ Failed to store auth code in sessionStorage:', e);
    }
  }
}

// Simple, stable mounting approach
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element 'root' not found in the DOM");
}

// Clear any existing content
rootElement.innerHTML = '';

// Create React root
const root = ReactDOM.createRoot(rootElement);

// Only use Strict Mode in development (not production)
// Strict Mode causes double renders which can interfere with auth callbacks
const isDevelopment = process.env.NODE_ENV !== 'production';

// Simple render
if (isDevelopment) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  root.render(<App />);
}

console.log('✅ Simple React app mounted successfully!', isDevelopment ? '(with Strict Mode)' : '(production mode)');
